// src/services/marketData/providerFactory.ts
import { MarketDataProvider } from './provider.interface';
import { AlphaVantageProvider } from './providers/alphaVantage.provider';
import { YahooFinanceProvider } from './providers/yahooFinance.provider';
import { AlpacaProvider } from './providers/alpaca.provider';

type ProviderType = 'alpha_vantage' | 'yahoo_finance' | 'alpaca';

export class ProviderFactory {
  private static providers: Record<ProviderType, MarketDataProvider> = {
    alpha_vantage: new AlphaVantageProvider(),
    yahoo_finance: new YahooFinanceProvider(),
    alpaca: new AlpacaProvider()
  };
  
  static getProvider(type: ProviderType): MarketDataProvider {
    if (!this.providers[type]) {
      throw new Error(`Provider ${type} not found`);
    }
    
    return this.providers[type];
  }
  
  static getDefaultProvider(): MarketDataProvider {
    // Default to Alpaca as the primary data provider
    return this.providers.alpaca;
  }
}
